// extracted by mini-css-extract-plugin
module.exports = {"container":"Statistics_container__3eNim","content":"Statistics_content__3VodB","contentInner":"Statistics_contentInner__2E7um"};